<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
  	return{
  		reload:this.reload
  	}
  },
  data(){
  	return{
  		isRouterAlive:true
  	}
  },
  methods:{
  	reload(){
  		this.isRouterAlive = false;
  		this.$nextTick(function(){
  			this.isRouterAlive = true;
  		})
  	}
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  /* margin-top: 70px; */
}
/*重置elementui样式*/
/* .el-dialog{width: 600px;}
.el-dialog__header {background: #eee;  text-align: left;}
.el-dialog__headerbtn{ top: 16px; font-size: 22px;}
.el-dialog__headerbtn:hover{border-color:#00AAFF;}
.el-dialog__body {font-size: 16px;}
.el-dialog__footer{text-align: center;}
.el-table{text-align: center;}
.el-table thead.is-group th,.el-table th { background: #E5F4FF;}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {border-right: 1px solid #ddd;}
.el-table--border th, .el-table__fixed-right-patch,.el-table td, .el-table th.is-leaf{border-bottom: 1px solid #ddd;}
.el-table--border, .el-table--group {border: 1px solid #ddd;}
.el-tooltip__popper{box-shadow: 0 5px 15px rgba(0,0,0,0.3); max-width: 400px;} */
</style>



// WEBPACK FOOTER //
// src/App.vue